import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'blaze-validator';
import Api from '../../services/ApiService';
import LoadingPage from '../LoadingPage';
import Form from '../form/Form';

class PrintPurchaseOrder extends PureComponent {
  constructor(props) {
    super(props);

    this.submit = this.submit.bind(this);

    let password = '';
    let purchaseOrderType = '';
    const passwordFieldName = 'A.POR_PO_51';
    const poType = 'purchaseOrderType';

    const form = props.formHandler.manager.getData();

    if (form[passwordFieldName]) {
      password = form[passwordFieldName].data;
    }
    if (form[poType]) {
      purchaseOrderType = form[poType].data;
    }

    this.layout = [
      {
        name: 'purchaseOrderId',
        label: 'Purchase Order #',
        type: 'string',
        hidden: true,
        readOnly: true,
        data: props.purchaseOrderId,
      },
      {
        col: 6,
        name: 'password',
        label: 'Password',
        type: 'password',
        data: password,
        dependencies: {
          and: [
            {
              '==': ['partsBased', 'Y'],
            },
          ],
          action: 'hide',
        },
      },
      {
        name: 'potype',
        label: 'purchaseOrderType',
        type: 'string',
        hidden: true,
        readOnly: true,
        data: purchaseOrderType,
      },
      {
        name: 'partsBased',
        hidden: true,
        readOnly: true,
        data: 'N',
      },
      {
        type: 'section',
        label: 'Basic Options',
        fields: [
          {
            col: 6,
            name: 'options',
            label: 'Output',
            type: 'string',
            required: true,
            noEmptyOption: true,
            options: [],
            data: '',
          },
          {
            col: 6,
            name: 'printer',
            label: 'Printer',
            type: 'string',
            required: true,
            noEmptyOption: true,
            options: [],
            data: '',
          },
          {
            col: 6,
            name: 'printNotes',
            label: 'Print Notes',
            options: [
              {
                value: 'N',
                label: 'No',
              },
              {
                value: 'Y',
                label: 'Yes',
              },
            ],
            noEmptyOption: true,
          },
        ],
      },
      {
        type: 'section',
        label: 'Parts Purchase Order Options',
        fields: [
          {
            col: 4,
            name: 'duplicate',
            label: 'Duplicate Parts',
            type: 'string',
            noEmptyOption: true,
            options: [
              {
                value: '',
                label: 'Do Not Combine',
              },
              {
                value: 'Y',
                label: 'Combine',
              },
            ],
            dependencies: {
              and: [
                {
                  '==': ['partsBased', 'Y'],
                },
              ],
              action: 'show',
            },
          },
          {
            col: 4,
            name: 'showCustomer',
            label: 'Customer Information',
            type: 'string',
            noEmptyOption: true,
            options: [
              {
                value: 'Y',
                label: 'Show Customer Information',
              },
              {
                value: '',
                label: 'Remove Customer Information',
              },
            ],
            dependencies: {
              and: [
                {
                  '==': ['partsBased', 'Y'],
                },
              ],
              action: 'show',
            },
          },
          {
            col: 4,
            name: 'unitPack',
            label: 'Print By Unit Pack',
            type: 'string',
            noEmptyOption: true,
            options: [
              {
                value: '',
                label: 'No',
              },
              {
                value: 'Y',
                label: 'Yes',
              },
            ],
            dependencies: {
              and: [
                {
                  '==': ['partsBased', 'Y'],
                },
              ],
              action: 'show',
            },
          },
        ],
      },
    ];

    this.state = {
      layout: [],
      isReady: false,
    };
  }

  componentDidMount() {
    const { purchaseOrderId } = this.props;

    this.props.setTitle(`Print Purchase Order (${purchaseOrderId})`);
    Api.get(`printers/${purchaseOrderId}`).then(response => {
      const layout = new Layout(this.layout);
      const printers = _.get(response, 'data.printers');
      const options = _.get(response, 'data.options');
      const partsBased = _.get(response, 'data.partsBased');
      layout.populateLayout({ printer: { options: printers }, options: { options }, partsBased });
      this.setState({
        isReady: true,
        layout: layout.getLayout(),
      });
    });
  }

  submit(payload) {
    return Api.post(`print/po/${payload.purchaseOrderId}`, payload);
  }

  render() {
    if (!this.state.isReady) {
      return <LoadingPage style={{ padding: '50px' }} />;
    }

    return (
      <Form
        exportFormat="object"
        feedback="none"
        onCancel={this.props.close}
        layout={this.state.layout}
        submit={this.submit}
        submitCallback={this.props.close}
        submitAll
        useDirtyWarning={false}
      />
    );
  }
}

PrintPurchaseOrder.propTypes = {
  close: PropTypes.func,
  formHandler: PropTypes.object,
  purchaseOrderId: PropTypes.string,
  setTitle: PropTypes.func,
};

export default PrintPurchaseOrder;
